import { render, staticRenderFns } from "./CmgMealBuilderItemSelectorCardMobileCustomizationsOverlay.vue?vue&type=template&id=9bd6d71e&scoped=true&lang=pug"
import script from "./cmg-meal-builder-item-selector-card-mobile-customizations-overlay.ts?vue&type=script&lang=ts&external"
export * from "./cmg-meal-builder-item-selector-card-mobile-customizations-overlay.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgMealBuilderItemSelectorCardMobileCustomizationsOverlay.vue?vue&type=style&index=0&id=9bd6d71e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd6d71e",
  null
  
)

export default component.exports